module.exports = __webpack_public_path__ + "static/interview-2963df6cf04f018b187af97fcfb6eb44.png";